// removed by extract-text-webpack-plugin
module.exports = {"container":"_1kzz5","textcontainer":"_1nzxR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHeader.less
// module id = 582
// module chunks = 0